import React from 'react';
import { Box, Typography, Stack, Divider, Avatar } from '@mui/material';

const rowSx = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const labelSx = { color: 'rgba(255,255,255,0.5)', fontWeight: 700 };

const PractitionerCard = ({ user, apiUrl }) => (
  <Box
    sx={{
      p: 3,
      bgcolor: '#1A202C',
      borderRadius: '12px',
      color: 'white',
      height: '100%',
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography
        variant="overline"
        sx={{ color: 'rgba(255,255,255,0.5)', fontWeight: 800 }}
      >
        Praticien / Expert
      </Typography>
      {user?.role_label && (
        <Typography
          variant="caption"
          sx={{
            bgcolor: 'rgba(79, 70, 229, 0.3)',
            color: '#A5B4FC',
            px: 1.5,
            py: 0.5,
            borderRadius: '6px',
            fontWeight: 800,
            textTransform: 'uppercase',
            fontSize: '0.65rem',
            letterSpacing: '0.5px',
          }}
        >
          {user.role_label}
        </Typography>
      )}
    </Box>

    <Stack direction="row" spacing={2} sx={{ mt: 2, mb: 3 }} alignItems="center">
      <Avatar
        src={`${apiUrl}/storage/workshop/${user?.photo_user}`}
        sx={{
          width: 64,
          height: 64,
          border: '3px solid rgba(255,255,255,0.2)',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        }}
      />
      <Box>
        <Typography sx={{ fontWeight: 800, fontSize: '1.1rem' }}>
          {user?.prenom_user} {user?.nom_user}
        </Typography>
        {user?.title_user ? (
          <Typography
            variant="body2"
            sx={{
              color: '#63B3ED',
              fontWeight: 700,
              bgcolor: 'rgba(99, 179, 237, 0.1)',
              px: 1,
              py: 0.2,
              borderRadius: '4px',
              display: 'inline-block',
              mt: 0.5,
            }}
          >
            {user.title_user}
          </Typography>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255,255,255,0.4)',
              fontStyle: 'italic',
              fontSize: '0.85rem',
              mt: 0.5,
            }}
          >
            Aucun titre spécifié
          </Typography>
        )}
      </Box>
    </Stack>

    <Box
      sx={{
        p: 2,
        bgcolor: 'rgba(255,255,255,0.05)',
        borderRadius: '8px',
        border: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <Stack spacing={1.5}>
        <Box sx={rowSx}>
          <Typography variant="caption" sx={labelSx}>
            CONTACT DIRECT
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {user?.phone_user || 'N/A'}
          </Typography>
        </Box>
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />
        <Box sx={rowSx}>
          <Typography variant="caption" sx={labelSx}>
            EMAIL
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#63B3ED', wordBreak: 'break-all' }}>
            {user?.email_user || 'N/A'}
          </Typography>
        </Box>
      </Stack>
    </Box>
  </Box>
);

export default PractitionerCard;